import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { BottomNav } from '../components/BottomNav';
import { TransactionItem } from '../components/TransactionItem';
import { walletBalance, transactions } from '../data/mockData';
export function Wallet() {
  const navigate = useNavigate();
  return <div className="min-h-screen pb-24" data-id="element-491">
      <div className="max-w-md mx-auto" data-id="element-492">
        {/* Header */}
        <div className="p-5 pt-8" data-id="element-493">
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-494">
            Wallet
          </h1>
        </div>

        <div className="px-5 space-y-5" data-id="element-495">
          {/* Premium Balance Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-gradient-to-br from-[#00D68F] to-[#00B377] rounded-[24px] p-6 relative overflow-hidden shadow-[0_10px_40px_-10px_rgba(0,214,143,0.3)]" data-id="element-496">
            <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-white/10 blur-2xl" data-id="element-497" />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-white/10 blur-xl" data-id="element-498" />

            <div className="relative z-10" data-id="element-499">
              <p className="text-white/70 text-xs tracking-widest uppercase font-semibold mb-2" data-id="element-500">
                Available Balance
              </p>
              <h2 className="text-white text-[40px] leading-none font-bold tracking-tight mb-8" data-id="element-501">
                ₦{walletBalance.available.toLocaleString()}
              </h2>

              <div className="flex justify-between items-end" data-id="element-502">
                <div className="flex gap-1" data-id="element-503">
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-504" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-505" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-506" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-507" />
                </div>
                <span className="text-white/40 text-sm font-bold tracking-widest" data-id="element-508">
                  KDX
                </span>
              </div>
            </div>
          </motion.div>

          <div className="grid grid-cols-2 gap-3" data-id="element-509">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="glass-card p-5" data-id="element-510">
              <div className="flex items-center gap-1.5 mb-2" data-id="element-511">
                <div className="w-1.5 h-1.5 rounded-full bg-[#FFBE0B]" data-id="element-512" />
                <p className="text-label" data-id="element-513">Pending</p>
              </div>
              <p className="text-white text-xl font-bold tracking-tight" data-id="element-514">
                ₦{walletBalance.pending.toLocaleString()}
              </p>
            </motion.div>

            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} whileTap={{
            scale: 0.97
          }} onClick={() => navigate('/wallet/withdraw')} className="glass-card border-[#00D68F]/30 p-5 flex flex-col items-center justify-center gap-1 text-[#00D68F] shadow-[0_0_15px_rgba(0,214,143,0.08)] hover:bg-[#00D68F]/10 transition-colors" data-id="element-515">
              <ArrowUpRight className="w-6 h-6" data-id="element-516" />
              <span className="font-bold tracking-tight" data-id="element-517">Withdraw</span>
            </motion.button>
          </div>

          {/* Transaction History */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="glass-card p-5" data-id="element-518">
            <h3 className="text-label mb-4" data-id="element-519">Transaction History</h3>

            <div className="divide-y divide-white/[0.04]" data-id="element-520">
              {transactions.map((transaction, index) => <motion.div key={transaction.id} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.4 + index * 0.05
            }} data-id="element-521">
                  <TransactionItem transaction={transaction} data-id="element-522" />
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>

      <BottomNav data-id="element-523" />
    </div>;
}